export default {
    url: 'camp',
    include: ['jp'],
};
